import { render } from "./IngredientsSelect.vue?vue&type=template&id=1b873928&scoped=true"
import script from "./IngredientsSelect.vue?vue&type=script&lang=js"
export * from "./IngredientsSelect.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1b873928"

export default script